import React, { Component, Fragment } from "react";
import moment from "moment";
import classnames from "classnames";
import { connect } from "react-redux";
import ReconciliationFilter from "../common/ReconciliationFilter";
import LoadingButton from "../../widgets/LoadingButton";
import { Masonry } from "../../widgets/Masonry";

import { loadDonorsWithFilter } from "../../../redux/actions/donor.actions";
import { loadRecipients } from "../../../redux/actions/recipient.actions";
import { Spinner, Card, Elevation, Checkbox } from "@blueprintjs/core";

const Json2csvParser = require("json2csv").Parser;

const CheckedCard = ({ donor, checked, onCheckDonor }) => {
  return (
    <div className="flex-container">
      <h3 className="flex-part">
        {donor.first_name} {donor.middle_name} {donor.last_name}
      </h3>
      <Checkbox
        alignIndicator="right"
        checked={Boolean(checked)}
        onChange={onCheckDonor}
      />
    </div>
  );
};

const DonorCardDetails = ({ donor, flipCard }) => {
  const renderLabeledValue = ({ label, value }) => {
    return (
      <p>
        <strong>{label}:</strong> {value}
      </p>
    );
  };
  return (
    <Fragment>
      {renderLabeledValue({ label: "E-mail", value: donor.email })}
      {renderLabeledValue({ label: "Phone", value: donor.phone })}
      {renderLabeledValue({ label: "Gender", value: donor.gender })}
      {renderLabeledValue({ label: "Local Church", value: donor.local_church })}
      {renderLabeledValue({
        label: "Location",
        value: `${donor.country_of_residence}, ${donor.city_of_residence}, ${
          donor.state_or_province
        }`
      })}
      {renderLabeledValue({
        label: "Address",
        value: `${donor.street_address}, ${donor.postal_code}`
      })}
      {renderLabeledValue({
        label: "MEF Sign Up Date",
        value: moment(donor.mef_signup_date).format("YYYY/MM/DD")
      })}
      {renderLabeledValue({ label: "Notes", value: donor.notes })}
      <div className="centered">
        <button onClick={flipCard} className="pt-button pt-intent-primary">
          Show Details
        </button>
      </div>
    </Fragment>
  );
};

class DonationsCardDetails extends Component {
  renderLabeledValue = ({ label, value }) => {
    return (
      <p>
        <strong>{label}:</strong> {value}
      </p>
    );
  };
  render() {
    const { flipCard } = this.props;
    const {
      donor: { donations_made },
      recipientState: { recipientsById }
    } = this.props;
    return (
      <Fragment>
        <div className="spinner-container">
          {donations_made ? (
            donations_made.map((donation, i) => {
              const recipient = donation.recipient_id
                ? recipientsById[donation.recipient_id]
                : null;
              return (
                <div key={i} className="progress-row">
                  Donation to{" "}
                  <strong>
                    {recipient
                      ? `${recipient.first_name} ${recipient.middle_name} ${
                          recipient.last_name
                        }`
                      : "N/A"}
                  </strong>{" "}
                  | ${donation.amount} ({donation.currency}) |{" "}
                  {moment(donation.donation_date).format("YYYY-MM-DD")} |{" "}
                  {donation.notes}
                </div>
              );
            })
          ) : (
            <Spinner large />
          )}
        </div>

        <div className="centered">
          <button onClick={flipCard} className="pt-button pt-intent-primary">
            Hide Details
          </button>
        </div>
      </Fragment>
    );
  }
}

class DonorCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: props.checkedDonors[props.donor.id],
      flipped: false
    };
  }
  componentWillReceiveProps(nextProps) {
    let checked = nextProps.checkedDonors[nextProps.donor.id];
    if (nextProps.checkAll) {
      checked = true;
    } else if (nextProps.uncheckAll) {
      checked = false;
    }
    this.setState({ checked });
  }
  onCheckDonor = id => {
    this.setState(
      ({ checked }) => ({ checked: !checked }),
      () => {
        this.props.onCheckDonor({ checked: this.state.checked, id });
      }
    );
  };
  flipCard = e => {
    e.stopPropagation();
    this.setState(({ flipped }) => ({
      flipped: !flipped
    }));
  };
  render() {
    const { donor } = this.props;

    return (
      <div
        className={classnames("cell flip-container", {
          flip: this.state.flipped
        })}
        onTouchStart={() => this.classList.toggle("hover")}
      >
        <div className="flipper">
          <div className="front" onClick={() => this.onCheckDonor(donor.id)}>
            <Card interactive elevation={Elevation.TWO}>
              {!this.state.flipped ? (
                <Fragment>
                  <CheckedCard
                    donor={donor}
                    onCheckDonor={() => this.onCheckDonor(donor.id)}
                    checked={this.state.checked}
                  />
                  <DonorCardDetails donor={donor} flipCard={this.flipCard} />
                </Fragment>
              ) : null}
            </Card>
          </div>
          <div className="back">
            <Card interactive elevation={Elevation.TWO}>
              {this.state.flipped ? (
                <DonationsCardDetails
                  recipientState={this.props.recipientState}
                  donor={donor}
                  flipCard={this.flipCard}
                />
              ) : null}
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

class DonorCards extends Component {
  state = {
    searchValue: ""
  };
  checkedDonors = {};
  checkAll = false;
  componentWillReceiveProps(nextProps) {
    if (this.props.checkAll !== nextProps.checkAll) {
      this.filteredDonors.forEach(d => {
        if (nextProps.checkAll) {
          this.checkedDonors[d.id] = nextProps.checkAll;
        } else {
          delete this.checkedDonors[d.id];
        }
        const event = new CustomEvent("checked-donor-changed", {
          detail: this.checkedDonors
        });
        window.dispatchEvent(event);
        this.checkAll = nextProps.checkAll;
        this.forceUpdate();
      });
    }
  }
  onCheckDonor = ({ checked, id }) => {
    if (checked) {
      this.checkedDonors[id] = true;
    } else {
      delete this.checkedDonors[id];
    }
    const event = new CustomEvent("checked-donor-changed", {
      detail: this.checkedDonors
    });
    window.dispatchEvent(event);
  };
  get filteredDonors() {
    const { donors } = this.props.donorState;
    const searchValue = this.state.searchValue.toLowerCase();
    return searchValue
      ? donors.filter(
          donor =>
            donor.first_name.toLowerCase().includes(searchValue) ||
            donor.middle_name.toLowerCase().includes(searchValue) ||
            donor.last_name.toLowerCase().includes(searchValue)
        )
      : donors;
  }
  render() {
    const filteredDonors = this.filteredDonors;
    return (
      <Fragment>
        <div className="filter-row">
          <input
            className="pt-input pt-fill"
            onChange={event =>
              this.setState({ searchValue: event.target.value })
            }
            placeholder="Search by donor name"
            dir="auto"
          />
        </div>
        {filteredDonors.length ? (
          <div className="masonry-container">
            <Masonry
              list={filteredDonors}
              customCellRenderer={(donor, i) => (
                <DonorCard
                  key={`${this.checkAll}${i}`}
                  recipientState={this.props.recipientState}
                  donor={donor}
                  checkedDonors={this.checkedDonors}
                  onCheckDonor={this.onCheckDonor}
                />
              )}
            />
          </div>
        ) : (
          <div className="intro clear">
            <div className="intro-text">No donors matching this name!</div>
          </div>
        )}
      </Fragment>
    );
  }
}

class SearchButton extends Component {
  state = {
    checkedDonors: {},
    isLoading: false
  };
  componentDidMount() {
    window.addEventListener(
      "checked-donor-changed",
      this.onCheckedDonorsChanged
    );
  }
  componentWillUnmount() {
    window.removeEventListener(
      "checked-donor-changed",
      this.onCheckedDonorsChanged
    );
  }
  onCheckedDonorsChanged = ({ detail }) => {
    this.setState({ checkedDonors: detail });
  };
  search = () => {
    const startDateFilter = this.props.startDate;
    const endDateFilter = this.props.endDate;

    const donorIds = Object.keys(this.state.checkedDonors);
    var donorData = donorIds.map(id => {
      return this.props.donorsById[id];
    });
    donorData.forEach(donorInfo => {
      var totalUSDDonations = 0;
      var totalCADDonations = 0;
      var totalOtherDonations = 0;
      donorInfo.donations_made.forEach(donation => {
        var startDate = moment(startDateFilter, "YYYY-MM-DD");
        var endDate = moment(endDateFilter, "YYYY-MM-DD");
        var compareDate = moment(
          moment(donation.donation_date).format("YYYY-MM-DD"),
          "YYYY-MM-DD"
        );
        if (
          compareDate.isBetween(startDate, endDate) ||
          compareDate.isSame(startDate) ||
          compareDate.isSame(endDate)
        ) {
          if (donation.currency === "CAD") {
            totalCADDonations += donation.amount;
          } else if (donation.currency === "USD") {
            totalUSDDonations += donation.amount;
          }
          else {
            totalOtherDonations += donation.amount;
          }
        }
      });
      donorInfo["Total US Donations"] = totalUSDDonations;
      donorInfo["Total CAD Donations"] = totalCADDonations;
      donorInfo["Total Other Donations"] = totalOtherDonations;
    });
    try {
      if (donorData.length) {
        const fields = Object.keys(donorData[0]).filter(
          key =>
            key !== "donations_made" &&
            key !== "recipients" &&
            key !== "creator_id" &&
            key !== "id" &&
            key !== "created_at" &&
            key !== "last_updated"
        );
        const parser = new Json2csvParser({ fields });
        const csv = parser.parse(donorData);

        //https://stackoverflow.com/questions/39374157/angular-save-file-as-csv-result-in-failed-network-error-only-on-chrome/39389497#39389497
        var blob = new Blob([csv], {type: 'text/csv'});
        var filename =  `${startDateFilter}_${endDateFilter}_donor-donation-info.csv`;
        if(window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(blob, filename);
        }
        else{
            var elem = window.document.createElement('a');
            elem.href = window.URL.createObjectURL(blob);
            elem.download = filename;
            document.body.appendChild(elem);
            elem.click();
            document.body.removeChild(elem);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };
  render() {
    const hasCheckedDonors = Object.keys(this.state.checkedDonors).length;
    return hasCheckedDonors ? (
      <div className="reconcile-btn">
        <LoadingButton
          className="pt-button pt-intent-primary pt-large"
          isLoading={this.state.isLoading}
          onClick={this.search}
          loadingText="Downloading"
          text="Download Data"
        />
      </div>
    ) : null;
  }
}

class DonorSearchTool extends Component {
  state = {
    checkAll: false
  };
  componentDidMount() {
    this.props.loadRecipients();
  }
  onCheckAll = () => {
    this.setState(({ checkAll }) => ({ checkAll: !checkAll }));
  };
  render() {
    const {
      allLoading,
      donors,
      donorsById,
      startDate,
      endDate
    } = this.props.donorState;
    return (
      <Fragment>
        <div className="reconciliation">
          <ReconciliationFilter
            loadData={this.props.loadDonorsWithFilter}
            allLoading={allLoading}
            isDate
            hasProvince
            hasRecipientAssigned
            checkAll={this.state.checkAll}
            onCheckAll={this.onCheckAll}
            actionButton={
              <SearchButton
                donorsById={donorsById}
                startDate={startDate}
                endDate={endDate}
              />
            }
            {...this.props}
          />
          <div className="reconciliation-content">
            {allLoading ? (
              <div className="spinner-container">
                <Spinner large />
              </div>
            ) : donors.length ? (
              <DonorCards checkAll={this.state.checkAll} {...this.props} />
            ) : (
              <div className="intro clear">
                <div className="intro-text">
                  No donations found for this date range!
                </div>
              </div>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default connect(
  state => ({
    donorState: state.donor,
    recipientState: state.recipient
  }),
  { loadDonorsWithFilter, loadRecipients }
)(DonorSearchTool);



// WEBPACK FOOTER //
// ./src/components/main/donor-search-tool/DonorSearchTool.js